<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="钉钉群告警管理列表">

            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="钉钉群名">
                    <a-input v-model="searchP.dingdingname" placeholder="钉钉群名"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                </a-form-item>

                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
                <router-link :to="{path:'dingdingadd'}" class="f-right">
                    <a-button type="primary" class="fr opbuttonmt">新增</a-button>
                </router-link>

            </a-form>
        </a-card>

        <!-- 分组列表 -->
        <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id">

            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <span>
                        <router-link :to="{ path:'dingdingedit', query: { id: record.id}}">编辑
                        </router-link>
                    </span>
                    <span v-if="record.flag == '02'">
                        <span>
                            <router-link v-if="typeflags.get(record.id).SLA" :to="{ path:'dingdingrelation', query: { alerttype: 'SLA',dingid: record.id, dingdingname: record.dingdingname,flag: record.flag}}">
                                订阅接口(SLA)
                            </router-link>
                        </span>
                        <span>
                            <router-link v-if="typeflags.get(record.id).JOB" :to="{ path:'dingdingrelation', query: { alerttype: 'JOB',dingid: record.id, dingdingname: record.dingdingname,flag: record.flag}}">
                                订阅接口(JOB)
                            </router-link>
                        </span>
                    </span>
                    <span v-else-if="record.flag == '03'">
                        <span>
                            <router-link v-if="typeflags.get(record.id).SLA" :to="{ path:'dingdingrelationsys', query: { alerttype: 'SLA',dingid: record.id, dingdingname: record.dingdingname,flag: record.flag}}">
                                订阅系统(SLA)
                            </router-link>
                        </span>
                        <span>
                            <router-link v-if="typeflags.get(record.id).JOB" :to="{ path:'dingdingrelationsys', query: { alerttype: 'JOB',dingid: record.id, dingdingname: record.dingdingname,flag: record.flag}}">
                                订阅系统(JOB)
                            </router-link>
                        </span>
                    </span>
                    <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                        <a href="javascript:;">删除</a>
                    </a-popconfirm>
                </div>
            </template>
            <template slot="dingflag" slot-scope="text, record">
                <span v-if="record.flag == '01'">
                    所有
                </span>
                <span v-else-if="record.flag == '02'">
                    指定接口
                </span>
                <span v-else-if="record.flag == '03'">
                    指定系统
                </span>
                <span v-else>
                    未知
                </span>
            </template>
            <template slot="dingtypes" slot-scope="types">
                <a-tag color="green" v-for="d in getTypeArr(types)" :key="d">
                    {{d}}
                </a-tag>
            </template>
        </a-table>

        <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
import { mapState } from 'vuex'
const data = []

let pagination = {
    total: 0,
    pageSize: 0,
    current: 1,
}
const columns = [
    {
        title: '序号',
        width: 40,
        align: 'center',
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination
            return (Number(current) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '钉钉群名',
        dataIndex: 'dingdingname',
        width: 50,
    },
    {
        title: '钉钉群Token',
        dataIndex: 'dingdingurl',
        width: 210,
    },
    {
        title: '告警范围',
        dataIndex: 'flag',
        width: 50,
        scopedSlots: { customRender: 'dingflag' },
    },
    {
        title: '告警内容',
        dataIndex: 'types',
        width: 50,
        scopedSlots: { customRender: 'dingtypes' },
    },
    {
        title: '状态',
        width: 50,
        align: 'center',
        customRender: (text, record) => {
            // debugger
            return record.switch == '1' ? '开启' : '关闭'
        },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 200,
        scopedSlots: { customRender: 'operation' },
    },
]

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            typeflags: new Map(),
            columns,
            pagination,
            tLoading: true,
            currentItemList: '',
            datasource: {
                isShow: false,
                authedStr: '',
            },
        }
    },
    methods: {
        handlePageChange(c_p) {
            this.getAlarmDingdingList(c_p)
        },
        getAlarmDingdingList(cpage) {
            let c_params = {
                ...this.searchP,
            }

            c_params.page = cpage ? cpage : 1
            c_params.pageSize = this.pagination.pageSize
            c_params.urlparams = false
            this.tLoading = true
            this.$store
                .dispatch({
                    type: 'alarmconfig/dingdinglist',
                    params: c_params,
                })
                .then((res) => {
                    // console.log(res)
                    this.tLoading = false
                    let result = res.data.data
                    if (result) {
                        // debugger
                        this.data = result.list
                        this.typeflags.clear()
                        result.list.forEach((element) => {
                            let sla =
                                this.getTypeArr(element.types).indexOf('SLA') >=
                                0
                            let job =
                                this.getTypeArr(element.types).indexOf('JOB') >=
                                0
                            this.typeflags.set(element.id, {
                                SLA: sla,
                                JOB: job,
                            })
                        })
                        // console.log(this.typeflags)
                        this.pagination.total = parseInt(result.totalRecords)
                        this.pagination.pageSize = parseInt(result.pageSize)
                        this.pagination.current = parseInt(result.page)
                    }
                })
        },

        handleSearchReset() {
            this.$store.dispatch({
                type: 'alarmconfig/getEmptySearch',
                showMsg: true,
            })
        },

        handleSubmit(e) {
            e.preventDefault()
            this.getAlarmDingdingList(1)
        },

        //删除
        onDelete(record) {
            this.$store
                .dispatch({
                    type: 'alarmconfig/dingdingdel',
                    params: record,
                })
                .then(() => {
                    this.getAlarmDingdingList(1)
                })
        },
        getTypeArr: (types) => {
            if (!types) {
                return []
            }
            return types.split(',')
        },
    },
    computed: {
        ...mapState('alarmconfig', {
            searchP: (state) => state.searchP,
        }),
    },

    mounted() {
        const { query } = this.$route
        this.getAlarmDingdingList(query)
    },
}
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}
td {
    padding: 10px 10px;
}
</style>
